import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { LucideDynamicIcon } from '@lucide/angular';
import { Heart, Home, Search, User } from '@core/icons/lucide.icons';

export interface NavItem {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  label: string;
  route: string;
}

@Component({
  selector: 'app-mobile-nav',
  imports: [LucideDynamicIcon],
  template: `
    <div class="border-border fixed right-0 bottom-0 left-0 z-50 border-t bg-white md:hidden">
      <nav class="safe-area-bottom grid grid-cols-4">
        @for (item of navItems; track item.id) {
          <button (click)="onNavigate(item.route)" [class]="getButtonClass(item.id)">
            <svg [lucideIcon]="item.icon" class="h-5 w-5"></svg>
            <span class="text-xs">{{ item.label }}</span>
          </button>
        }
      </nav>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .safe-area-bottom {
        padding-bottom: env(safe-area-inset-bottom);
      }

      .nav-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
        padding: 0.75rem 0;
        transition: color 0.2s;
      }

      .nav-button-active {
        color: #3b82f6;
      }

      .nav-button-inactive {
        color: #9ca3af;
      }

      .nav-button-inactive:hover {
        color: #4b5563;
      }
    `,
  ],
})
export class MobileNavComponent {
  currentPage = input<string>('home');
  navigate = output<string>();

  // Navigation items
  navItems: NavItem[] = [
    { id: 'home', icon: Home, label: 'Home', route: '/' },
    { id: 'search', icon: Search, label: 'Explore', route: '/search' },
    { id: 'favorites', icon: Heart, label: 'Favorites', route: '/favorites' },
    { id: 'profile', icon: User, label: 'Profile', route: '/profile' },
  ];

  onNavigate(route: string) {
    this.navigate.emit(route);
  }

  getButtonClass(itemId: string): string {
    const isActive =
      this.currentPage() === itemId || (itemId === 'profile' && this.currentPage() === 'account');

    return `nav-button ${isActive ? 'nav-button-active' : 'nav-button-inactive'}`;
  }
}
